import { render, staticRenderFns } from "./StackedBar.vue?vue&type=template&id=93689f52&scoped=true&"
import script from "./StackedBar.vue?vue&type=script&lang=js&"
export * from "./StackedBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93689f52",
  null
  
)

export default component.exports